import React from "react";
import { renderToString } from "react-dom/server";
import { Ban } from "@procore/core-icons";
import { StringHelper } from "@bryntum/core-thin";
import { formatTimeBryntum, getDatesRangeString } from "../../gantt-container";
import type { TimeOffTooltipProps } from "../../resource-schedule/resource-schedule-types";

export const renderTimeOffTooltip = ({
   name,
   jobTitleName,
   jobTitleColor,
   timeOffReason,
   startDate,
   endDate,
   startTime,
   endTime,
   isPaid,
   applyToSaturday,
   applyToSunday,
   repeat,
   I18n,
}: TimeOffTooltipProps): string => {
   const startTimeFormatted = formatTimeBryntum(startTime);
   const endTimeFormatted = formatTimeBryntum(endTime);
   const banIcon = renderToString(<Ban size="sm" color="#232729" />);

   return StringHelper.xss`
      <div class='gantt-project-tooltip ganttDayOffTooltip'>
         <div class='gantt-project-tooltip__header'>
               <span class="gantt-project-tooltip-color-icon" style="color: ${jobTitleColor}"></span>
               <b>${name}</b>
               <span class='job-title dayOffTooltipSecondary'>${jobTitleName}</span>
         </div>
         <hr>
         <div class='gantt-project-tooltip__footer'>
               <div>
                  <b>${I18n.t(
                     "views.company.workforce_planning.gantt.time_off_tooltip.time_off",
                  )}</b><br>
               </div>
            <div class='flex' style="gap: 0">
               <div style="min-width: 200px">
                  <b>${I18n.t("views.company.workforce_planning.gantt.tooltip.dates")} </b><br>
                  ${getDatesRangeString(startDate, endDate)}
               </div>
               <div style="min-width: 200px">
                  <b>${I18n.t("views.company.workforce_planning.gantt.tooltip.times")}</b><br>
                  ${startTimeFormatted} - ${endTimeFormatted}
               </div>
            </div>
            <div class='flex' style="gap: 0">
               <div style="min-width: 200px">
                  <b>${I18n.t(
                     "views.company.workforce_planning.gantt.time_off_tooltip.reason",
                  )}</b><br>
                  <span class="dayOffTooltipSecondary">${timeOffReason}</span>
               </div>
               <div style="min-width: 200px">
                  <b>${I18n.t(
                     "views.company.workforce_planning.gantt.time_off_tooltip.type",
                  )}</b><br>
                   <span class="dayOffTooltipSecondary">${
                      isPaid
                         ? I18n.t("views.company.workforce_planning.gantt.time_off_tooltip.paid")
                         : I18n.t("views.company.workforce_planning.gantt.time_off_tooltip.unpaid")
                   }</span>
               </div>
            </div>
            <div class='flex' style="gap: 0">
               <div style="min-width: 200px">
                  <b>${I18n.t(
                     "views.company.workforce_planning.gantt.time_off_tooltip.weekends",
                  )}</b><br>
                  <div style="display: flex; ${applyToSaturday ? "display: none" : ""}">
                  <img src="data:image/svg+xml;base64,${btoa(banIcon)}" style="margin-right: 8px">
                  <span>${I18n.t(
                     "views.company.workforce_planning.gantt.time_off_tooltip.saturday",
                  )}</span>
                  </div>
                  <div style="display: flex; ${applyToSunday ? "display: none" : ""}">
                  <img src="data:image/svg+xml;base64,${btoa(banIcon)}" style="margin-right: 8px">
                  <span>${I18n.t(
                     "views.company.workforce_planning.gantt.time_off_tooltip.sunday",
                  )}</span>
                  </div>
               </div>
               <div style="min-width: 200px">
                  <b>${I18n.t(
                     "views.company.workforce_planning.gantt.time_off_tooltip.repeat",
                  )}</b><br>
                  <span class="dayOffTooltipSecondary repeat">${
                     repeat
                        ? I18n.t(
                             `views.company.workforce_planning.time_off.${repeat.toLowerCase()}`,
                          )
                        : ""
                  }</span>
               </div>
            </div>
         </div>
      </div>
   `;
};
